import AbstractCompanySettingsPageController from '../abstract-company-controller';
import askForLeavingWithoutSavingChanges
    from '../../../../modules/core/helpers/routing/ask-for-leaving-without-saving-changes';

export default class AbstractCustomFieldsSettingsPageController extends AbstractCompanySettingsPageController {

    constructor($scope, $injector) {
        super($scope, $injector);

        askForLeavingWithoutSavingChanges(this);

        this.dataChanged = false;
        this.allowRoute = true;
        this.submitting = false;

        this.customFieldModels = {};
        this.originalCustomFieldModels = {};

        this.headline = this._getHeadline();
    }

    $onInit() {
        this._initWatchers();
        super.$onInit();
    }

    save(form) {
        if (!form.$valid) {
            return;
        }
        this.submitting = true;

        this.api.put(`company`, this._prepareCompanyDataForApi())
            .then(() => {
                this.alert.success(
                    this.translate.instant('general.alerts.change_save_success.title'),
                    this.translate.instant('general.alerts.change_save_success.content'),
                );

                location.reload();
            })
            .catch((e) => {
                this.submitting = false;
                this._loadUserAndCompany();
                console.error('Error while updating company', e);

                this.alert.error(
                    this.translate.instant('general.alerts.change_save_error.title'),
                    this.translate.instant('general.alerts.change_save_error.content'),
                )
            });
    }

    discardChanges() {
        this.customFieldModels = _.cloneDeep(this.originalCustomFieldModels);
    }

    _handleUserAndCompanyLoaded() {
        super._handleUserAndCompanyLoaded();

        this.customs = this._getCustomFields();
        this._prepareCustomFieldModels();
    }

    _getHeadline() {
        return 'Custom fields';
    }

    _getCustomFieldCount() {
        console.warn('custom field count not defined')
        return 0;
    }

    _getCustomFieldSuffix() {
        console.warn('custom field suffix not defined')
        return '';
    }

    _getCustomFields() {
        return _.range(1, this._getCustomFieldCount());
    }

    _getFilteredModel() {
        const out = _.cloneDeep(this.customFieldModels);

        _.each(out, (v, k) => {
            if (!v || !v.type) {
                delete out[k];
            }
        })

        return out;
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.customFieldModels,
            () => {
                this.dataChanged = !_.isEqual(
                    this._getFilteredModel(),
                    this.originalCustomFieldModels
                );
                this.allowRoute = !this.dataChanged;
            },
            true
        );
    }


    _prepareCustomFieldModels() {
        const newModels = {};

        for (let i = 1; i <= this._getCustomFieldCount(); i++) {
            const currentField = _.get(this.company, `custom_${i}${this._getCustomFieldSuffix()}`, null);
            if (currentField) {
                newModels[i] = currentField;
            }
        }

        this.customFieldModels = _.cloneDeep(newModels);

        this.originalCustomFieldModels = this._getFilteredModel();
        this.customFieldModels = _.cloneDeep(this.originalCustomFieldModels);
    }

    _prepareCompanyDataForApi() {
        const newModel = _.cloneDeep(this.company),
            filteredModel = this._getFilteredModel();

        for (let i = 1; i <= this._getCustomFieldCount(); i++) {
            const currentField = _.get(filteredModel, i, null);
            if (currentField) {
                newModel[`custom_${i}${this._getCustomFieldSuffix()}`] = currentField;
            }
        }

        return newModel;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/controllers/custom-fields/abstract-custom-fields.js